import React from 'react';

import Tooltip, { TooltipProps } from 'react-scale/components/tour/ui/tooltip';
import TooltipSpot from 'react-scale/components/tour/ui/spot';
import AttachTooltip from 'react-scale/components/tour/helpers/attachTooltip';

export interface AttachedTooltipProps
  extends Omit<TooltipProps, 'top' | 'left' | 'right' | 'bottom'> {
  offsetX?: number;
  offsetY?: number;
  showWithSpot?: boolean;
  attachDisplay?: 'block' | 'inline-block' | 'flex';
  top?: number | string;
  left?: number | string;
  right?: number | string;
  bottom?: number | string;
  position?: 'relative' | 'absolute';
  alignSelf?: 'center' | 'start' | 'end';
  delay?: number;
  tooltipColor?: string;
  arrowPositionTop?: string;
  children?: React.ReactNode;
}

interface AttachedTooltipState {
  show: boolean;
}

export default class AttachedTooltip extends React.Component<
  AttachedTooltipProps,
  AttachedTooltipState
> {
  static defaultProps: Partial<AttachedTooltipProps> = {
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
  };

  constructor(props: AttachedTooltipProps) {
    super(props);

    this.state = {
      show: false,
    };

    this.onShowTooltipWithSpot = this.onShowTooltipWithSpot.bind(this);
  }

  onShowTooltipWithSpot() {
    this.setState({ show: true });
  }

  renderBody({
    top,
    left,
    right,
    bottom,
    showWithSpot,
    props,
  }: {
    props: TooltipProps;
    top: React.ReactText;
    left: React.ReactText;
    right: React.ReactText;
    bottom: React.ReactText;
    showWithSpot?: boolean;
  }) {
    const showTooltip = (this.state.show && showWithSpot) || !showWithSpot;
    const showSpot = !this.state.show && showWithSpot;

    return (
      <div style={{ position: 'absolute' }}>
        {showTooltip && <Tooltip {...props} top={top} left={left} right={right} bottom={bottom} />}

        {showSpot && (
          <TooltipSpot
            attachPosition={props.arrow}
            top={top}
            left={left}
            right={right}
            bottom={bottom}
            onEnter={this.onShowTooltipWithSpot}
          />
        )}
      </div>
    );
  }

  render() {
    const {
      children,
      position,
      alignSelf,
      attachDisplay,
      offsetX,
      offsetY,
      showWithSpot,
      delay,
      ...props
    } = this.props;

    if (position === 'absolute') {
      return this.renderBody({
        top: props.top || 'auto',
        left: props.left || 'auto',
        right: props.right || 'auto',
        bottom: props.bottom || 'auto',
        showWithSpot,
        props,
      });
    }

    return (
      <AttachTooltip
        content={children}
        attachPosition={props.arrow}
        offsetX={offsetX}
        offsetY={offsetY}
        attachDisplay={attachDisplay}
        delay={delay}
        position={position}
        alignSelf={alignSelf}
      >
        {({ top, left, right, bottom }) =>
          this.renderBody({ top, left, right, bottom, showWithSpot, props })
        }
      </AttachTooltip>
    );
  }
}
